import { createFileRoute } from "@tanstack/react-router";

import { CollectionPage } from "../../../workspaces/production/pages/CollectionPage";
import { useSeat } from "../../../workspaces/production/seat";

/** One collection: a page of its own, which links back to the list. */
export const Route = createFileRoute("/_console/production/collections_/$collectionId")({
  component: Collection,
});

function Collection() {
  const { collectionId } = Route.useParams();
  return <CollectionPage collectionId={collectionId} role={useSeat()} />;
}
